import Table from './Table';
import Placeholder from './RankingPlaceholder';

const TYPES = {
    default: Table,
    placeholder: Placeholder,
};

/**
 * Get the type component based on type and state
 *
 * @param {{type: string, locked: boolean}} type
 * @returns {class}
 */
export default function getRankingComponent(type) {
    let Content = TYPES[type];
    return Content;
}
